import { useState } from "react";
import { KindergartenSearchComponent } from "../../../components/form/components/KindergartenSearchComponent";
import { PageHeader } from "../../../components/header/PageHeader";
import { kindergartenCheckerListTable, kindergartenCheckerOptions } from "../../../shared/tableObjects/admin/kindergartenCheckerListTable";
import Table, { tableOptions } from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { eventEmitter } from "../../../shared/event";
export default function KindergartenCheckerList() {
  const apiClient = useApiClient("AdminApplication");

  const [kindergartenName, setKindergartenName] = useState<any>("");
  const [year, setYear] = useState<any>("");
  const [tableOptions, setTableOptions] = useState<tableOptions>(kindergartenCheckerOptions);
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "Kindergarten Checker",
      icon: "open-books-icon icon-spec",
    },
  ];

  const clearSearch = () => {
    setKindergartenName("");
    setYear("");
    eventEmitter.removeListener("clearSearch", clearSearch);
  };

  const handleSearch = (newKinderName: string, newYear: string) => {
    setKindergartenName(newKinderName);
    setYear(newYear);
    setTableOptions({
      ...tableOptions,
      filters: {
        ["fundedKinderName"]: {
          searchFilter: newKinderName,
        },
        ["yearApplied"]: { searchFilter: newYear },
      },
    });
    eventEmitter.once("clearSearch", clearSearch);
  };
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table kindergarten-checker">
        <KindergartenSearchComponent search={handleSearch}></KindergartenSearchComponent>

        {(kindergartenName != "" || year != "") && (
          <Table
            key={`${kindergartenName}-${year}`}
            apiClient={apiClient}
            route={"kinderChecker"}
            label={""}
            columns={kindergartenCheckerListTable("applications")}
            tableOptions={tableOptions}
          />
        )}
      </div>
    </>
  );
}
